<template>
    <v-text-field :rules="[val => $validator.phone(getValidatorVal(), $attrs.label)]" :value="value" @input="valueChanged" v-bind="$attrs" dense outlined ref="textfield"></v-text-field>
</template>
<style lang="scss">
    .v-application{
        .iti__search-input{
            max-height: none;
            padding: 10px 15px;
        }

        .iti__country-list{
            padding: 0;
        }
    }
</style>
<style lang="css" scoped>
    >>> .v-label{
        left: 45px !important;
    }

    >>> .v-label.v-label--active{
        left: 0px !important;
    }
</style>
<script lang="js">
    import intlTelInput from 'intl-tel-input';
    import 'intl-tel-input/build/css/intlTelInput.css';
    import { nl } from "intl-tel-input/i18n";

    export default {
        name: 'eod-phone-field',
        props:{
            value: String
        },
        data: () => {
            return {
                element: null,
            }
        },
        mounted(){
            if(this.$refs.textfield){
                const input = this.$refs.textfield.$refs.input;
                setTimeout(() => {
                    this.element = intlTelInput(input, {
                        loadUtils: () => import("intl-tel-input/utils"),
                        containerClass: 'v-input v-input--hide-details w-100',
                        i18n: nl,
                        initialCountry: 'be',
                        onlyCountries: ['nl','be','de', 'fr'],
                        autoPlaceholder: 'off'
                    });
                }, 100);
                
            }
        },
        methods: {
            getValidatorVal(){
                if(!this.element){
                    return null;
                }
                
                return this.element.getNumber();
            },
            valueChanged(val){
                if(this.element.isValidNumber()){
                    val = this.element.getNumber();
                }

                this.$emit('input', val);
            }
        }
    }
</script>